
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { ChevronLeft } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { useEffect } from "react";

const BegleitungPage = () => {
  const navigate = useNavigate();
  
  const handleNavigateBack = () => {
    navigate(-1);
    setTimeout(() => {
      const section = document.getElementById('ns3');
      if (section) {
        const offset = -80;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset + offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 100);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const { data: images } = useQuery({
    queryKey: ["images", "begleitung"],
    queryFn: async () => {
      console.log("Fetching images for begleitung section");
      const { data, error } = await supabase
        .from("images")
        .select("*")
        .eq("section", "begleitung")
        .order('created_at', { ascending: true });
      
      if (error) throw error;
      console.log("Retrieved images:", data);
      return data;
    },
  });

  const getImageUrl = (index: number) => {
    if (images && images[index]) {
      const { data } = supabase.storage
        .from('images')
        .getPublicUrl(images[index].storage_path);
      return data.publicUrl;
    }
    return 'https://images.unsplash.com/photo-1516156008625-3a9d6067fab5?auto=format&fit=crop&q=80';
  };

  const experiences = [
    {
      title: "EINFÜHLSAM & VERSTÄNDNISVOLL",
      content: "Einfühlsame und verständnisvolle Begleitung von Menschen in ihren tiefsten Tälern bei Beerdigungen & in der Sterbegleitung und höchsten Höhen bei Hochzeiten und Taufen",
    },
    {
      title: "BEGLEITUNG JUGENDLICHER",
      content: "Begleitung von Jugendlichen und jungen Erwachsenen in der Konfirmanden- und Jugendarbeit mit all ihren Fragen und Zweifeln. Intensive Konfirmandenwochenden mit kreativer gemeinsamer Erarbeitung der Inhalte, die den Jugendlichen extrem viel Spaß machten.",
    },
    {
      title: "AKADEMISCHE BEGLEITUNG",
      content: "Tutorials für deutsche Studierende als Co-Studienleiter eines Studienprogramms in Jerusalem und Begleitung & Unterstützung der Studierenden in ihrer beruflichen Orientierung und Wegfindung.",
    },
    {
      title: "ORIENTIERUNGSHILFE",
      content: "Begleitung von Menschen in der Seelsorge, die unzufrieden mit ihrer Lebenssituation waren und Orientierung suchten.",
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-r from-[#243949] to-[#517fa4]">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4" />
              <ChevronLeft className="w-4 h-4 -ml-2" />
            </div>
          </Button>
          
          <h2 className="text-lg md:text-xl font-bold text-white text-center uppercase flex-grow">
            Einfühlsame Begleitung
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto space-y-6">
          <div className="aspect-[21/9] w-full mb-8">
            <img
              src={getImageUrl(0)}
              alt="Begleitung Bild"
              className="rounded-lg object-cover w-full h-full border border-[#9F9EA1]"
            />
          </div>

          {experiences.map((experience, index) => (
            <div 
              key={index}
              className="bg-white/10 backdrop-blur-sm p-6 rounded-lg border-2 hover:border-white/40 transition-all duration-300"
            >
              <h3 className="text-base font-semibold text-white mb-4 uppercase">
                {experience.title}
              </h3>
              <p className="text-base text-white text-left">
                {experience.content}
              </p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default BegleitungPage;
